<template>
  <v-hover v-slot="{isHovering, props}">
    <v-sheet v-bind="props" class="pip-video">
      <div class="pip-container">
        <video
          :class="{'video-hidden': !displayVideo}"
          ref="video"
          autoplay
          muted
          playsinline
          @enterpictureinpicture="enterPipHandler"
          @leavepictureinpicture="leavePipHandler"
        ></video>
        <v-icon v-if="session.notClientCamera" icon="msf:videocam_off" :size="60" color="#ffffff" />
        <v-icon v-else-if="session.notClientPresent" icon="msf:pause" :size="60" color="#ffffff" />
        <v-icon
          v-if="isHovering && pictureInPictureEnabled && displayVideo"
          :icon="pip ? 'pip_exit' : 'pip'"
          :size="60"
          color="#ffffff"
          @click="pipHandler"
        />
      </div>
    </v-sheet>
  </v-hover>
</template>

<script setup>
import {ref, watchEffect, onUnmounted} from 'vue'
import {useSessionStore} from '@/stores'
import {useRemoteStream} from '@/composables'
import {computed} from 'vue'
import {storeToRefs} from 'pinia'

const session = useSessionStore()
const {notClientCamera, notClientPresent} = storeToRefs(session)
const {video: remoteVideoStream} = useRemoteStream()
const video = ref(null)
const pip = ref(false)

const {pictureInPictureEnabled} = document
const displayVideo = computed(() => !notClientCamera.value && !notClientPresent.value)
function pipHandler() {
  if (pip.value) {
    document.exitPictureInPicture()
  } else {
    video.value.requestPictureInPicture()
  }
}

function enterPipHandler() {
  pip.value = true
}

function leavePipHandler() {
  pip.value = false
}

watchEffect(() => {
  if (video?.value) {
    video.value.srcObject = remoteVideoStream.value
  }
})
watchEffect(() => {
  if (!displayVideo.value && document.pictureInPictureElement) {
    document.exitPictureInPicture()
  }
})

onUnmounted(() => {
  if (pip.value) {
    document.exitPictureInPicture()
  }
})
</script>

<style lang="scss" scoped>
$video-bg: $black;
$video-size: 18rem;
$video-border: 1px solid $white;
$video-bottom-offset: ($component-height + $layout-spacer-sm);
$video-btn-color: $white;
$video-btn-backdrop: rgba($gray-500, 0.4);

.pip-video {
  position: absolute;
  right: 12px;
  bottom: 12px;
  background-color: $video-bg;
  border: $video-border;
  border-radius: $border-radius;
  overflow: hidden;
  z-index: $zindex-component;
  .pip-container {
    position: relative;
    width: fit-content;
    height: fit-content;
    video {
      max-width: $video-size;
      max-height: $video-size;
      object-fit: contain;
      display: block;
      &.video-hidden {
        opacity: 0;
        transition: opacity 0.3s ease;
      }
    }
    .v-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
